/* ============================================================
   Hidden-variant submit guard.

   Last line of defence for the custom.hidden_variant loophole (see
   snippets/variant-picker.liquid, buy-buttons.liquid, and
   hidden-variant-redirect.liquid for the rest of the fix). Those three
   handle the two real entry points -- the form's own default value, and a
   direct ?variant=<hidden id> link -- by never letting a hidden variant
   become the resolved/submitted one in the first place.

   This is a static, sitewide, delegated listener rather than something
   scoped to any one template on purpose: a quick-buy modal's content gets
   fetched from the product's own page and cloned into whatever page the
   modal was opened from (see QuickBuyModal.show() in theme.js), and
   cloned <script> tags don't execute -- so anything living inside that
   cloned content can't be relied on to run. A listener bound once, here,
   on every real page load, keeps working regardless of how or when a
   matching form later shows up in the DOM, since delegated event
   listening doesn't care how a descendant got there.

   The data it checks against (data-hidden-variant-ids on <product-form>)
   is a plain HTML attribute, not a script -- those DO survive cloning,
   which is exactly why buy-buttons.liquid carries the id list that way
   instead of trying to pass it through a script tag.
   ============================================================ */

(function () {
  if (window.__hettasHiddenVariantGuardBound) return;
  window.__hettasHiddenVariantGuardBound = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.closest !== 'function') return;

      var productForm = form.closest('product-form[data-hidden-variant-ids]');
      if (!productForm) return;

      var hiddenIds = productForm
        .getAttribute('data-hidden-variant-ids')
        .split(',')
        .filter(Boolean);
      if (hiddenIds.length === 0) return;

      var idField = form.querySelector('input[name="id"]');
      if (!idField) return;

      if (hiddenIds.indexOf(idField.value) > -1) {
        event.preventDefault();
        event.stopPropagation();
        // This should never actually trigger in normal use -- the form's
        // own default is already resolved away from hidden variants, and
        // the main PDP redirects off a hidden variant's URL outright. If
        // this fires, something upstream regressed; worth knowing about.
        console.error(
          '[hettas] Blocked an add-to-cart submission for a hidden variant (id ' +
            idField.value +
            '). This should not be reachable through normal storefront use -- investigate how the form ended up with this value.'
        );
      }
    },
    true
  );
})();
